import { render, staticRenderFns } from "./DecompositionDetailsActionsCard.vue?vue&type=template&id=11fc2ba8"
import script from "./DecompositionDetailsActionsCard.vue?vue&type=script&lang=js"
export * from "./DecompositionDetailsActionsCard.vue?vue&type=script&lang=js"
import style0 from "./DecompositionDetailsActionsCard.vue?vue&type=style&index=0&id=11fc2ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports